import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

/**
 * Hook to fetch all VGC formats where a specific Pokemon has appeared.
 * Handles the case where the backend index is still being built (returns building: true).
 */
const usePokemonFormats = (pokemonName) => {
    const [formats, setFormats] = useState([]);
    const [loading, setLoading] = useState(false);
    const [building, setBuilding] = useState(false);
    const [error, setError] = useState(null);
    const pollRef = useRef(null);

    useEffect(() => {
        if (!pokemonName) return;

        let cancelled = false;

        const fetchFormats = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await axios.get(`/api/pokemon-formats/${encodeURIComponent(pokemonName)}`);

                if (cancelled) return;

                if (response.status === 202 || response.data.building) {
                    setBuilding(true);
                    setLoading(false);
                    // Poll every 8 seconds until the index is ready
                    pollRef.current = setTimeout(fetchFormats, 8000);
                    return;
                }

                setBuilding(false);
                setFormats(response.data.formats || []);
            } catch (err) {
                if (!cancelled) {
                    setError(err.message);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        fetchFormats();

        return () => {
            cancelled = true;
            if (pollRef.current) clearTimeout(pollRef.current);
        };
    }, [pokemonName]);

    return { formats, loading, building, error };
};

export default usePokemonFormats;
